import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { DialogService } from "src/app/core/services/dialog.service";

@Component({
  selector: "app-change-password-dialog",
  templateUrl: "./change-password-dialog.component.html",
  styleUrls: ["./change-password-dialog.component.scss"]
})
export class ChangepasswordDialogComponent {

  constructor(public dialogService: DialogService,
    public router: Router) {
  }

  redirectToMaxBet() {
    this.dialogService.closeDialog();
    window.open("http://www.maxbet.rs", "_blank");
  }

  goBack() {
    this.dialogService.closeDialog();
  }
}
